export const LESSON_FEATURE_KEY = 'lesson';
